module.exports = __webpack_public_path__ + "static/media/SR.a96b947d.svg";